{
  "version": "1.2.6",
  "objects": {
    "7535235936136318301": {
      "type": "frame",
      "id": "7535235936136318301",
      "z": 9717,
      "textContent": "",
      "left": 67.33171601232416,
      "top": 2264.0328599736267,
      "width": 1110,
      "height": 625,
      "scaleX": 0.285454827642828,
      "scaleY": 0.20680310098507834,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 30,
      "layoutPadding": 20,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7535235936144689772": {
      "type": "frame",
      "id": "7535235936144689772",
      "z": -665,
      "textContent": "",
      "left": 87.33171601232416,
      "top": 2340.7936656471875,
      "width": 1110,
      "height": 625,
      "scaleX": 0.24941879160679198,
      "scaleY": 0.05198581190738141,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7535235936136318301",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a23UV",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7535235936139267091": {
      "type": "frame",
      "id": "7535235936139267091",
      "z": 89,
      "textContent": "",
      "left": 162.11367115448894,
      "top": 2340.7936656471875,
      "width": 1110,
      "height": 625,
      "scaleX": 0.11215417337127316,
      "scaleY": 0.05198581190738141,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7535235936144689772",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0BvQ",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 30,
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7535235936144811233": {
      "type": "shape",
      "id": "7535235936144811233",
      "z": 90,
      "shapeName": "icon",
      "textContent": "",
      "left": 162.11367115448894,
      "top": 2350.0392318682443,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.16,
      "scaleY": 0.16,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#333333",
      "angle": 0,
      "container": "7535235936139267091",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1216",
      "wrapText": true,
      "maskType": "none",
      "iconName": "fas/backward",
      "locked": false
    },
    "7535235936143166074": {
      "type": "shape",
      "id": "7535235936143166074",
      "z": 91,
      "shapeName": "icon",
      "textContent": "",
      "left": 208.11367115448894,
      "top": 2341.7936656471875,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.32491132442113385,
      "scaleY": 0.32491132442113385,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#333333",
      "angle": 0,
      "container": "7535235936139267091",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a230x",
      "wrapText": true,
      "maskType": "none",
      "iconName": "fas/circle-play",
      "locked": false
    },
    "7535235936138027197": {
      "type": "shape",
      "id": "7535235936138027197",
      "z": 92,
      "shapeName": "icon",
      "textContent": "",
      "left": 270.6048035966023,
      "top": 2350.0392318682443,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.16,
      "scaleY": 0.16,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#333333",
      "angle": 0,
      "container": "7535235936139267091",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a36Es",
      "wrapText": true,
      "maskType": "none",
      "iconName": "fas/forward",
      "locked": false
    },
    "7535235936146994134": {
      "type": "shape",
      "id": "7535235936146994134",
      "z": 8958,
      "shapeName": "icon",
      "textContent": "",
      "left": 87.33171601232416,
      "top": 2348.49767406529,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.1708311560590812,
      "scaleY": 0.1708311560590812,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#000000",
      "angle": 0,
      "container": "7535235936144689772",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "ZzwGP5AZ",
      "maskType": "none",
      "iconName": "fas/shuffle",
      "locked": false
    },
    "7535235936149698689": {
      "type": "shape",
      "id": "7535235936149698689",
      "z": 8968,
      "shapeName": "icon",
      "textContent": "",
      "left": 344.30364313285884,
      "top": 2349.097766086742,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.15882931563004432,
      "scaleY": 0.15882931563004432,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#000000",
      "angle": 0,
      "container": "7535235936144689772",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a21yD",
      "maskType": "none",
      "iconName": "fas/repeat",
      "locked": false
    },
    "7535235936144714159": {
      "type": "frame",
      "id": "7535235936144714159",
      "z": 88,
      "textContent": "",
      "left": 87.33171601232439,
      "top": 2284.0328599736267,
      "width": 1110,
      "height": 625,
      "scaleX": 0.24941879160679156,
      "scaleY": 0.042817289077697024,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7535235936136318301",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a16NT",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": 5,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7535235936137182011": {
      "type": "wireframe",
      "id": "7535235936137182011",
      "z": 93,
      "top": 2284.0328599736267,
      "left": 87.61838770058208,
      "width": 433.61264172847535,
      "height": 42,
      "scaleX": 0.6371620398466806,
      "scaleY": 0.6371620398466806,
      "container": "7535235936144714159",
      "layoutPosition": "a13ag",
      "wireframeName": "slider",
      "fill": "#000000",
      "textColor": "#333333",
      "fontSize": 14,
      "label": {},
      "placeholder": {},
      "setDimension": true,
      "progress": 0.7247806846998212
    }
  }
}
